// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $section = $('#presell');

    if ($section.length > 0) {
      // Altera o tipo de fundo
      function changeBgType() {
        const value = confTheme[ref2]['bg-type'];
        if (value == 'image') {
          changeBgImage();
        } else if (value == 'gradient') {
          changeBgGradient();
        } else if (value == 'color') {
          changeBgColor();
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

      // Altera a imagem de fundo
      function changeBgImage() {
        const image = confTheme[ref2]['bg-image'];
        $section.css('background-image', 'url(' + image + ')');
      }
      $root.on(refEvtPrefix + 'bg-image', changeBgImage);

      // Altera o gradiente de fundo
      function changeBgGradient() {
        const value = confTheme[ref2]['bg-gradient'];
        $section.css('background-image', value);
      }
      $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

      // Altera a cor de fundo
      function changeBgColor() {
        const color = confTheme[ref]['presell-bg-color'];
        $section.css('background-image', 'none');
        $section[0].style.setProperty('--presell-bg-color', color);
      }
      $root.on(refEvtPrefix + 'bg-color', changeBgColor);
    }
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $section = $('#presell');
    const $secTitle = $('.presell-titulo');
    const $secSubtitle = $('.presell-subtitulo');
    const $secText = $('.presell-texto');

    if ($section.length > 0) {
      // Altera o alinhamento dos textos
      function changeTextAlign() {
        const value = confTheme[ref2]['text-align'];
        $section.removeClass('presell-text-center presell-text-left').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'text-align', changeTextAlign);

      // Altera o título
      function changeTitle() {
        const value = confTheme[ref2]['titulo'];
        $secTitle.html(fmtTxt(value, true));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

      // Altera a cor do título
      function changeTitColor() {
        const color = confTheme[ref]['presell-tit-color'];
        $section[0].style.setProperty('--presell-tit-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

      // Altera o subtítulo
      function changeSubtitle() {
        const value = confTheme[ref2]['subtitulo'];
        $secSubtitle.html(fmtTxt(value));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'subtitulo', changeSubtitle);

      // Altera a cor do subtítulo
      function changeSubColor() {
        const color = confTheme[ref]['presell-sub-color'];
        $section[0].style.setProperty('--presell-sub-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'sub-color', changeSubColor);

      // Altera o texto
      function changeText() {
        const value = confTheme[ref2]['texto'];
        $secText.html(fmtTxt(value));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

      // Altera a cor do texto
      function changeTxtColor() {
        const color = confTheme[ref]['presell-txt-color'];
        $section[0].style.setProperty('--presell-txt-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);
    }
  }
})();

// ------------------------------------
// TIPO DE CONTEÚDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $section = $('#presell');

    if ($section.length > 0) {
      // Altera o título
      function changeSectinTypeContent() {
        const value = confTheme[ref2]['tipo_conteudo'];
        $section.removeClass('presell-blank presell-with-image presell-with-video').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tipo-conteudo', changeSectinTypeContent);

      // Altera a posição da imagem/vídeo
      function changeMediaPosition() {
        const value = confTheme[ref2]['media-position'];
        $section.find('.presell-image-video-wrp').removeClass('media-top').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'media-position', changeMediaPosition);
    }
  }
})();

// ------------------------------------
// IMAGEM
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $image = $('.presell-image');

    if ($image.length > 0) {
      // Altera a imagem
      function changeImage() {
        const image = confTheme[ref2]['img-src'];
        $image.find('img').attr('src', image);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-src', changeImage);

      // Altera o texto alternativo da imagem
      function changeImageAlt() {
        const value = confTheme[ref2]['img-alt'];
        $image.find('img').attr('alt', value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-alt', changeImageAlt);

      // Altera o formato da imagem
      function changeImageFormat() {
        const value = confTheme[ref2]['img-format'];
        $image.find('.img').removeClass('img-square img-rounded img-circle').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-format', changeImageFormat);
    }
  }
})();

// ------------------------------------
// VÍDEO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $video = $('.presell-video .embed');

    if ($video.length > 0) {
      // Altera o vídeo
      function changeVideo() {
        const videoUrl = confTheme[ref2]['video_url'];
        const videoID = confTheme[ref2]['video_id'];
        const videoPlataform = confTheme[ref2]['video_plataforma'];
        $video.removeClass('video-loaded');
        $video.data('video-id', videoID);
        $video.data('video-plataform', videoPlataform);
        $video.html('');
        $video.append(createVideoThumb(videoID, videoPlataform));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video', changeVideo);

      // Altera o formato do vídeo
      function changeVideoFormat() {
        const value = confTheme[ref2]['video-format'];
        $video.removeClass('embed-16-9 embed-4-3 embed-1-1 embed-9-16').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-format', changeVideoFormat);

      // Altera a thumbnail
      function changeVideoThumb() {
        const image = confTheme[ref2]['video-thumbnail'];
        $video.find('.embed-item').css('background-image', 'url(' + image + ')');
      }
      $root.on(refEvtPrefix + 'video-thumbnail', changeVideoThumb);
    }
  }
})();

// ------------------------------------
// LISTA
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $list = $('#presell-botoes');

    if ($list.length > 0) {
      // Altera a lista
      function changeList() {
        const lista = confTheme[ref2]['botoes'];
        if ($list.length > 0) {
          $list.html('');
          for (let i = 0; i < lista.length; i++) {
            const styleClass = confTheme['general'][lista[i]['btn-class'] + '-style'];
            const AnimationClass = confTheme['general'][lista[i]['btn-class'] + '-animation'];
            const item = `
            <li><a href="${lista[i].url}?>" class="btn ${lista[i]['btn-class']} ${styleClass} ${AnimationClass}">${lista[i]['btn-text']}</a></li>`;
            $list.append(item);
          }
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'botoes', changeList);
    }
  }
})();

// ------------------------------------
// COMENTÁRIOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'presell-var';
    const ref2 = 'presell';
    const refEvtPrefix = 'lp-evt-presell-';

    // Elementos
    const $section = $('#presell-comments');
    const $secTitle = $('.presell-comments-title');
    const $secText = $('.presell-comments-text');
    const $list = $('.presell-comments-list');
    const $listCount = $('.presell-comments-count');

    if ($section.length > 0) {
      // Oculta/Exibe a seção
      function changeSecShow() {
        const value = confTheme[ref2]['comments-show'];
        value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comments-show', changeSecShow);

      // Altera o título
      function changeTitle() {
        const value = confTheme[ref2]['comments-titulo'];
        $secTitle.html(fmtTxt(value, true));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comments-titulo', changeTitle);

      // Altera a cor do título
      function changeTitColor() {
        const color = confTheme[ref]['presell-comments-tit-color'];
        $section[0].style.setProperty('--presell-comments-tit-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comments-tit-color', changeTitColor);

      // Altera o texto
      function changeText() {
        const value = confTheme[ref2]['comments-texto'];
        $secText.html(fmtTxt(value));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comments-texto', changeText);

      // Altera a cor do texto
      function changeTxtColor() {
        const color = confTheme[ref]['presell-comments-txt-color'];
        $section[0].style.setProperty('--presell-comments-txt-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comments-txt-color', changeTxtColor);

      // Altera a lista
      function changeList() {
        const lista = confTheme[ref2]['comentarios'];
        $listCount.text('(' + lista.length + ')');
        if ($list.length > 0) {
          $list.html('');
          for (let i = 0; i < lista.length; i++) {
            const firstLetter = lista[i].titulo.substr(0, 1);
            const item = `
            <li class="presell-comment">
              <div class="presell-comment-profile">${firstLetter}</div>
              <div class="presell-comment-infos">
                <div class="presell-comment-title">${lista[i].titulo} <span>${lista[i].data}</span></div>
                <div class="presell-comment-text">${lista[i].texto}</div>
                <div class="presell-comment-controls">
                  <a href="#" class="presell-comment-like">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"/></svg>
                    Curtir
                  </a>
                  <a href="#" class="presell-comment-reply">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"/></svg>
                    Responder
                  </a>
                </div>
              </div>
            </li>`;
            $list.append(item);
          }
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comentarios', changeList);
    }
  }
})();
